import { render, staticRenderFns } from "./UserRegisterInvite.vue?vue&type=template&id=2464f4cf&scoped=true&"
import script from "./UserRegisterInvite.vue?vue&type=script&lang=js&"
export * from "./UserRegisterInvite.vue?vue&type=script&lang=js&"
import style0 from "./UserRegisterInvite.vue?vue&type=style&index=0&id=2464f4cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464f4cf",
  null
  
)

export default component.exports